export default __webpack_public_path__ + "static/media/new-feia-mobile-popup.39777884.png";